<script setup>
import { useDetailsReport } from '#/detailsReport/useDetailsReport'
import mapboxgl from 'mapbox-gl'
import { onMounted, watch, ref, inject } from 'vue'
import PotentialMapUIV1 from '#/detailsReport/version1/PotentialMapUIV1'
import PotentialMapUIV2 from '#/detailsReport/version2/PotentialMapUIV2'
const { potential, version, mapStyle } = useDetailsReport()
const { application, pages, screen, global } = inject('Shared')
const mapObj = ref(null)

watch(() => mapStyle.value, (newVal) => {
  switch (newVal) {
    case 'LIGHT': mapObj.value.setStyle('mapbox://styles/mapbox/light-v10'); setTimeout(() => { loadMapFeatures(true, true) }, 100); break
    case 'SATELLITE': mapObj.value.setStyle('mapbox://styles/mapbox/satellite-v9'); setTimeout(() => { loadMapFeatures(true, true) }, 100); break
  }
})

onMounted(async () => {
  if (potential.value) {
    initMap()
  }
})

const initMap = () => {
  try {
    if (!mapObj.value) {
      let container
      if (application === 'WIDGET' && process.env.NODE_ENV === 'production') {
        const shadow = document.querySelector('#app').shadowRoot
        container = shadow.querySelector('#potentialPageMap')
      } else {
        container = 'potentialPageMap'
      }
      mapboxgl.accessToken = 'pk.eyJ1IjoiZXh3b3JtIiwiYSI6ImNrcGZjYmQxYTA0NWsydW1zZTlzdXM0dWkifQ.KsByqOYmJaRdRvv-5XeBAg'
      mapObj.value = new mapboxgl.Map({
        container,
        style: 'mapbox://styles/mapbox/light-v10',
        center: [potential.value.long, potential.value.lat],
        zoom: 14,
        pitch: 0,
        bearing: 0,
        interactive: false,
        preserveDrawingBuffer: true
      })
      mapObj.value.on('load', function () {
        loadMapFeatures()
      })
    } else {
      loadMapFeatures()
    }
  } catch (e) {
    console.log('INITMAPERROR', e)
  }
}

const loadMapFeatures = () => {
  try {
    if (!potential.value) {
      console.log('Lead not yet loaded')
      return
    }
    mapObj.value.addSource('geometryCoordinates', { type: 'geojson', data: { type: 'Feature', geometry: { type: 'Polygon', coordinates: [potential.value.parcel.geometryCoordinates.map(e => [e.lat, e.lon])] } } })
    mapObj.value.addLayer({ id: 'geometryCoordinates', type: 'fill', source: 'geometryCoordinates', layout: {}, paint: { 'fill-color': global.value.mapbox.fillColor || 'rgba(95, 239, 192, 0.4)' || '#5FEFC0', 'fill-opacity': global.value.mapbox.fillOpacity || 0.5 } })
    mapObj.value.addLayer({ id: 'outline', type: 'line', source: 'geometryCoordinates', layout: {}, paint: { 'line-color': global.value.mapbox.outlineColor || '#5FEFC0', 'line-width': global.value.mapbox.outlineLineWidth || 2 } })
    mapObj.value.flyTo({
      center: [potential.value.long, potential.value.lat],
      zoom: screen.gt.xs ? 17 : 15.5,
      bearing: 0,
      speed: 1,
      curve: 1,
      easing: (t) => t,
      essential: true
    })
  } catch (e) {
    console.log(e)
  }
}
</script>

<template lang="pug">
potential-map-u-i-v1(v-if="version === 1")
potential-map-u-i-v2(v-else-if="version === 2")
</template>

<style scoped lang="sass">
</style>
